export const DEFAULT_FRAMING = { x: 0.5, y: 0.5, zoom: 1 };

const pct = (v) => `${(v * 100).toFixed(1)}%`;

/** Non-destructive framing → inline style for an object-cover <img>. */
export const frameStyle = (f) => {
  if (!f) return undefined;
  const pos = `${pct(f.x)} ${pct(f.y)}`;
  return { objectPosition: pos, transformOrigin: pos, transform: f.zoom > 1 ? `scale(${f.zoom})` : undefined };
};

/** Scale `sizes` by zoom so the browser picks a sharp enough derivative (no blur at 2x). */
export const framedSizes = (sizes, zoom = 1) => {
  if (!zoom || zoom <= 1) return sizes;
  return sizes.split(",").map((part) => {
    const t = part.trim();
    const i = t.lastIndexOf(" ");
    const cond = t.startsWith("(") && i > 0 ? t.slice(0, i) : "";
    const len = cond ? t.slice(i + 1) : t;
    return `${cond} calc(${len} * ${zoom.toFixed(2)})`.trim();
  }).join(", ");
};
